import { Box } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { TeamIconCircle } from "../../../../../components/mobile/TeamIconCircle";
import {
  ListSectionHeader,
  ListSectionHeaderTitle,
} from "../../../../../components/atoms/ListSectionHeader";
import { ListSectionHeaderRoutine_Routine$key } from "./__generated__/ListSectionHeaderRoutine_Routine.graphql";

export function ListSectionHeaderRoutine(props: {
  routine: ListSectionHeaderRoutine_Routine$key;
}) {
  const data = useFragment(
    graphql`
      fragment ListSectionHeaderRoutine_Routine on Routine {
        title
        ownerTeam {
          ...TeamIconCircleComponent_Team
        }
      }
    `,
    props.routine
  );

  return (
    <ListSectionHeader>
      <Box spaceRight="small">
        {data.ownerTeam ? (
          <TeamIconCircle team={data.ownerTeam} size="smallMedium" />
        ) : null}
      </Box>
      <ListSectionHeaderTitle>{data.title}</ListSectionHeaderTitle>
    </ListSectionHeader>
  );
}
